import * as Phaser from 'phaser';
import { PROPS, propTextureSize } from '../../sim/map/index.ts';
import { isBoatWorkshopRequested, isBotWorkshopRequested, isEditorRequested } from '../mode.ts';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload(): void {
    this.load.svg('boat', 'assets/svg/boat.svg', { width: 256, height: 128 });

    for (const prop of PROPS) {
      const size = propTextureSize(prop.id);
      this.load.svg(prop.texture, `assets/svg/${prop.texture}.svg`, {
        width: size,
        height: size,
      });
    }
  }

  create(): void {
    const search = globalThis.location.search;
    const next = isBoatWorkshopRequested(search)
      ? 'BoatScene'
      : isBotWorkshopRequested(search)
        ? 'BotScene'
        : isEditorRequested(search)
          ? 'EditorScene'
          : 'StartScene';
    this.scene.start(next);
  }
}
